import moment from "moment";
import React from "react";
import { TORB1Record } from "../../../../../redux/app/orb1/@types";
import ORB1TableRows, { ORB1TableColumns } from "../ORB1TableRows";
import { marpolUtils } from "../../../../../redux/app/marpol";
import { TORB1GroupC8 } from "redux/app/orb1/groups/group-c";

type OwnProps = {
	orb1Record: TORB1Record;
	isStrikedOff?: boolean;
};
function ORB1GroupC8Preview(props: OwnProps) {
	const orb1Record = props.orb1Record as TORB1GroupC8;
	if (orb1Record.item12P1.transferOfOilResidues.length === 0) return null;
	const firstOilResidue = orb1Record.item12P1.transferOfOilResidues[0];
	const operationDate = moment(orb1Record.selectedDate, "YYYY-MM-DD").format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<ORB1TableRows
				record={orb1Record}
				tableRows={[
					[operationDate, "C", "12.1", renderItem12P1()],
					[null, null, "NOTE", orb1Record.remarks],
				]}
			/>
		);
	}

	function renderItem12P1() {
		const { transferQuantity, selectedTank } = firstOilResidue;
		const { port, receiptNumber, receiptAttachment, barge } = orb1Record.item12P1;

		const processedTank = marpolUtils.getProcessedTank(selectedTank, orb1Record.processedTanks);

		return (
			<h4 className="font-medium uppercase">
				{transferQuantity.toFixed(2)} M³ OF SLUDGE FROM {marpolUtils.getFormattedName(selectedTank)}{" "}
				<br />
				{processedTank.newQuantity.toFixed(2)} M³ RETAINED, TO BARGE {barge} <br />
				DURING PORT STAY {port} <br />
				RECEIPT NO: <b>{receiptNumber}</b>
				<br />
				ATTACHMENT:
				{receiptAttachment}
			</h4>
		);

		return (
			<h4 className="font-medium uppercase">
				{transferQuantity.toFixed(2)} M³ DELIVERED TO {port} PORT RECEPTION FACILITIES <br /> FROM{" "}
				{marpolUtils.getFormattedName(selectedTank)}. RECEIPT NO: <b>{receiptNumber}</b>
				<br />
				QUANTITY RETAINED IN TANK ={processedTank.newQuantity.toFixed(2)} M³,
				<br />
				ATTACHMENT:
				{receiptAttachment}
			</h4>
		);
	}

	return renderMain();
}

export default ORB1GroupC8Preview;
